import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { CameraAlt, CameraAltOutlined, Refresh, UploadFile } from '@mui/icons-material';

const CapturePreviewCard = ({
  title,
  image,
  required,
  onRetake,
  onCapture,
  onUpload,
  stepKey,
  previewFrameRef,
  qualityResult,
}) => {
  const uploadInputId = `upload-${stepKey}`;

  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, p: { xs: 1.5, sm: 2 } }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: { xs: 13, sm: 14 } }}>
          {title} {required ? '(required)' : '(optional)'}
        </Typography>

        <Box
          ref={previewFrameRef}
          sx={{
            width: '100%',
            aspectRatio: '4 / 3',
            borderRadius: 2,
            bgcolor: '#f3f4f6',
            border: '1px dashed #cbd5e1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {image ? (
            <img
              src={image}
              alt={title}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                objectPosition: 'center',
                background: '#e5e7eb',
              }}
            />
          ) : (
            <CameraAlt sx={{ color: '#64748b', fontSize: 42 }} />
          )}

        </Box>

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1, width: '100%' }}>
          {image ? (
            <Button size="small" variant="outlined" startIcon={<Refresh fontSize="small" />} onClick={onRetake} sx={{ flex: 1 }}>
              Retake
            </Button>
          ) : (
            <Button size="small" variant="outlined" startIcon={<CameraAltOutlined fontSize="small" />} onClick={onCapture} sx={{ flex: 1 }}>
              Capture
            </Button>
          )}

          <Button
            size="small"
            variant="outlined"
            component="label"
            startIcon={<UploadFile fontSize="small" />}
            sx={{ flex: 1 }}
          >
            Upload
            <input
              id={uploadInputId}
              type="file"
              accept="image/*"
              hidden
              onChange={onUpload}
            />
          </Button>
        </Box>

        {image && qualityResult ? (
          <Box
            sx={{
              mt: 0.5,
              p: 1,
              borderRadius: 1.5,
              bgcolor: qualityResult.success ? '#ecfdf5' : '#fef2f2',
              border: `1px solid ${qualityResult.success ? '#86efac' : '#fecaca'}`,
            }}
          >
            <Typography variant="caption" fontWeight={700} sx={{ display: 'block' }}>
              {qualityResult.loading ? 'Quality check in progress...' : qualityResult.message}
            </Typography>
            {!qualityResult.loading ? (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                {/* Angle: {qualityResult.angle || 'N/A'} | */}
                Faces: {qualityResult.face_count ?? 0} | Pose: {qualityResult.pose_quality ?? 0} | Lighting: {qualityResult.lighting_quality ?? 0} | Score: {qualityResult.quality_score ?? 0} | Similarity: {qualityResult.similarity ?? 'N/A'} | Embedding: {qualityResult.encoding_dimension ?? 0}
              </Typography>
            ) : null}
          </Box>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default CapturePreviewCard;
